export const getFirstName = (fullName) => {
  if (!fullName) return 'User';
  return fullName.split(' ')[0];
};

export const getLastName = (fullName) => {
  if (!fullName) return 'User';
  return fullName.split(' ').slice(1).join(' ');
};